import { render, staticRenderFns } from "./RenalNonCystic.vue?vue&type=template&id=95213f62"
import script from "./RenalNonCystic.vue?vue&type=script&lang=js"
export * from "./RenalNonCystic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports